import { ConnectorStore, IConnectorProps, IObject } from 'connect-store';
import iziToast, { IziToastSettings } from 'izitoast';
import * as React from 'react';
import BacklogPointLoader from '../../classes/loaders/BacklogPointLoader';

const backlogPointLoader = new BacklogPointLoader();

export interface IBacklogPoint extends React.Attributes, IObject {
  other: any;
  callback: IFunction;
  properties?: IObject;
}

export class BacklogPoint extends React.Component<IBacklogPoint> {

  public state = {
    name: '',
    radius: '',
    warningNumber: '',
  };

  public render(): JSX.Element | null {
    const { name, radius, warningNumber } = this.state;
    const { callback, other, properties } = this.props as any;
    const modifyObject = backlogPointLoader.geojson.features.find(item => item.properties!.id === properties);
    const style = {
      marginLeft: 10,
      border: 'none',
      borderBottom: '1px solid #e0e0e0',
    };
    const modifyName = modifyObject && modifyObject.properties && modifyObject.properties.info && modifyObject.properties.info.name;
    const modifyRadius = modifyObject && modifyObject.properties && modifyObject.properties.info && modifyObject.properties.info.radius;
    const modifyWarningNumber = modifyObject && modifyObject.properties && modifyObject.properties.info && modifyObject.properties.info.warningNumber;
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <label>名称:<input
          style={style}
          value={name || modifyName || ''}
          type="text"
          onChange={e => this.setState({ name: e.target.value })}
        />
        </label>
        <label>半径:<input
          style={style}
          value={radius || modifyRadius || ''}
          type="number"
          onChange={e => this.setState({ radius: e.target.value })}
        /></label>
        <label>警戒数:<input
          style={style}
          value={warningNumber || modifyWarningNumber || ''}
          onChange={e => this.setState({ warningNumber: e.target.value })}
          type="number"
        /></label>
        <button
          onClick={() => {
            (async _ => {
              if (properties) {
                await callback(name || modifyName, radius || modifyRadius, warningNumber || modifyWarningNumber, other);
              } else {
                await callback(name, radius, warningNumber, other);
                this.setState({
                  name: '',
                  radius: '',
                  warningNumber: '',
                });
              }
            })().catch((e: Error) => iziToast.error({ title: e.message } as IziToastSettings));
          }}
        >提交
        </button>
      </div>
    );
  }
}

export const backlogFunction = (callback: IFunction, other: any) => {
  return (
    <BacklogPoint other={other} callback={callback}/>
  );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/views/popUp/BacklogPoint.tsx